module.exports = __webpack_public_path__ + "img/br30.d15a44a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/br30.jpg
// module id = ZsJ2
// module chunks = 0